(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('unitJuridicalDocuments', UnitJuridicalDocuments)

    /** @ngInject */
    function UnitJuridicalDocuments($q, $rootScope, $timeout, NotifyService, HelperService, JuridicalDocumentService, sweetAlert, PATHS_FRANCHISER, ROUTES) {
        function UnitJuridicalDocumentsDirectiveController($scope) {
            const vm = this;

            vm.juridicalDocumentData = {};
            vm.selectedJuridicalDocumentType = null;
            vm.juridicalDocuments = [];
            vm.juridicalTypes = [];
            vm.selectedFile = null;
            vm.renewalOptions = [];
            vm.isDistractModal = false;
            vm.relatedJuridicalDocument = null;
            vm.datePickerConfig = {};
            vm.datePickerOpen = {};
            vm.datePickerModels = {};

            let removeWatchShow = $scope.$watchGroup(['vm.show', 'vm.unitData && vm.unitData.Id'], values => {
                const isVisible = values[0];
                const unitId = values[1];

                if (isVisible && unitId)
                    init();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            vm.flowFileAdded = $file => {
                let blacklist = ['pdf'];
                let extension = ($file.getExtension() || '').toLowerCase();

                if (!blacklist.includes(extension)) {
                    NotifyService.error('Apenas arquivos no formato PDF sao permitidos.');
                    HelperService.setErrorMessageForm('.juridical-upload', 'Formato invalido.', true);
                    return false;
                }

                vm.selectedFile = $file.name;
                HelperService.removeErrorMessageForm('.juridical-upload');
            }

            vm.flowFileFinished = ($file, $message) => {
                let message = angular.fromJson($message);

                saveJuridicalDocument(message);
            }

            vm.flowFileError = $flow => {
                if ($flow && $flow.files)
                    $flow.files = [];

                HelperService.stopLoading('.modal-loader');
                NotifyService.error('Nao foi possivel enviar o documento.');
            }

            vm.getJuridicalDocumentUrl = juridicalDocument => {
                if (!vm.unitData || !vm.unitData.Id || !juridicalDocument || !juridicalDocument.AzureFileName)
                    return '';

                return `${ROUTES.API}/juridical-document/${vm.unitData.Id}/${juridicalDocument.AzureFileName}`;
            }

            vm.isRenovationType = type => {
                if (!type || !type.Description)
                    return false;

                return normalizeText(type.Description).indexOf('RENOVACAO') > -1;
            }

            vm.isDistractDocument = juridicalDocument => {
                return !!(juridicalDocument && juridicalDocument.RelatedJuridicalDocumentId);
            }

            vm.getRenewalLabel = renewalNumber => {
                const option = vm.renewalOptions.find(x => x.Value == renewalNumber);
                return option ? option.Description : '';
            }

            vm.getRelatedJuridicalDocument = juridicalDocument => {
                if (!juridicalDocument || !juridicalDocument.RelatedJuridicalDocumentId)
                    return null;

                return vm.juridicalDocuments.find(x => x.Id == juridicalDocument.RelatedJuridicalDocumentId) || null;
            }

            vm.getDocumentTypeLabel = juridicalDocument => {
                if (!juridicalDocument || !juridicalDocument.JuridicalDocumentType)
                    return '';

                if (vm.isDistractDocument(juridicalDocument))
                    return `Distrato - ${juridicalDocument.JuridicalDocumentType.Description}`;

                return juridicalDocument.JuridicalDocumentType.Description;
            }

            vm.showDistractModal = juridicalDocument => {
                vm.showJuridicalModal(null, juridicalDocument);
            }

            vm.toggleDatePicker = field => {
                syncDatePickerModel(field);

                Object
                    .keys(vm.datePickerOpen)
                    .forEach(key => vm.datePickerOpen[key] = key == field ? !vm.datePickerOpen[key] : false);
            }

            vm.setDateFromPicker = (field, newDate) => {
                if (!field || !newDate)
                    return;

                vm.juridicalDocumentData[`${field}Formatted`] = moment(newDate).format('DD/MM/YYYY');
                vm.datePickerOpen[field] = false;
            }

            vm.saveJuridicalDocument = () => {
                if (!vm.unitData || !vm.unitData.Id)
                    return;

                if (!vm.selectedJuridicalDocumentType) {
                    HelperService.setErrorMessageForm('.juridical-document-type');
                    return;
                }

                if (!vm.selectedFile) {
                    HelperService.setErrorMessageForm('.juridical-upload');
                    return;
                }

                HelperService.startLoading('.modal-loader');

                if (vm.flowScope && vm.flowScope.flow && vm.flowScope.flow.opts)
                    angular.extend(vm.flowScope.flow.opts, vm.flowOptions);

                $timeout(() => {
                    if (vm.flowScope && vm.flowScope.flow && vm.flowScope.flow.files.length)
                        vm.flowScope.flow.upload();
                    else
                        saveJuridicalDocument();
                })
            }

            vm.deleteJuridicalDocument = juridicalDocumentId => {
                sweetAlert.swal({
                    title: 'Voce tem certeza?',
                    text: 'Essa acao nao podera ser desfeita!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Nao, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.startLoading('.loading-holder');

                        JuridicalDocumentService
                            .delete(juridicalDocumentId)
                            .then(() => {
                                vm.juridicalDocuments = vm.juridicalDocuments.filter(x => x.Id != juridicalDocumentId);

                                HelperService.successCallback('delete');
                                HelperService.stopLoading('.loading-holder');
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.loading-holder');
                            })
                    }
                })
            }

            vm.showJuridicalModal = (juridicalDocument = null, relatedJuridicalDocument = null) => {
                let modalAction = 'NOVO';
                vm.juridicalDocumentData = {};
                vm.selectedJuridicalDocumentType = null;
                vm.selectedFile = null;
                vm.isDistractModal = false;
                vm.relatedJuridicalDocument = null;
                resetDatePickerState();

                if (relatedJuridicalDocument) {
                    vm.isDistractModal = true;
                    vm.relatedJuridicalDocument = relatedJuridicalDocument;
                    vm.selectedJuridicalDocumentType = vm.juridicalTypes.find(x => x.Id == relatedJuridicalDocument.JuridicalDocumentTypeId) || null;
                    vm.juridicalDocumentData = {
                        RelatedJuridicalDocumentId: relatedJuridicalDocument.Id,
                        Description: `Distrato vinculado ao documento ${relatedJuridicalDocument.FileName || relatedJuridicalDocument.Id}`
                    };
                    modalAction = 'NOVO DISTRATO';
                }

                if (juridicalDocument) {
                    vm.isDistractModal = vm.isDistractDocument(juridicalDocument);
                    vm.relatedJuridicalDocument = vm.getRelatedJuridicalDocument(juridicalDocument);
                    vm.selectedJuridicalDocumentType = vm.juridicalTypes.find(x => x.Id == juridicalDocument.JuridicalDocumentTypeId) || null;
                    vm.selectedFile = juridicalDocument.FileName;
                    vm.juridicalDocumentData = angular.copy(juridicalDocument);
                    vm.juridicalDocumentData.SignatureDateFormatted = juridicalDocument.SignatureDate ? moment(juridicalDocument.SignatureDate).format('DD/MM/YYYY') : '';
                    vm.juridicalDocumentData.DistractDateFormatted = juridicalDocument.DistractDate ? moment(juridicalDocument.DistractDate).format('DD/MM/YYYY') : '';
                    vm.juridicalDocumentData.RenovationDateFormatted = juridicalDocument.RenovationDate ? moment(juridicalDocument.RenovationDate).format('DD/MM/YYYY') : '';
                    syncAllDatePickerModels();

                    modalAction = vm.isDistractModal ? 'EDITAR DISTRATO' : 'EDITAR';
                }

                $('#juridical-document').appendTo('body').modal('show');
                vm.modalAction = modalAction;
            }

            vm.closeJuridicalModal = () => {
                vm.juridicalDocumentData = {};
                vm.selectedJuridicalDocumentType = null;
                vm.selectedFile = null;
                vm.isDistractModal = false;
                vm.relatedJuridicalDocument = null;
                resetDatePickerState();

                if (vm.documentForm && angular.isFunction(vm.documentForm.reset))
                    vm.documentForm.reset();

                if (vm.flowScope && vm.flowScope.flow && vm.flowScope.flow.files.length)
                    vm.flowScope.flow.cancel();

                $('#juridical-document').modal('hide');
            }

            function saveJuridicalDocument(fileUploaded) {
                let juridicalDocument = angular.copy(vm.juridicalDocumentData) || {};

                if (!vm.unitData || !vm.unitData.Id || !vm.selectedJuridicalDocumentType || !vm.selectedJuridicalDocumentType.Id) {
                    HelperService.stopLoading('.modal-loader');
                    return;
                }

                if (fileUploaded) {
                    juridicalDocument.FileName = fileUploaded.FileName;
                    juridicalDocument.AzureFileName = fileUploaded.FileSaveName;
                }

                juridicalDocument.UnitId = vm.unitData.Id;
                juridicalDocument.JuridicalDocumentTypeId = vm.selectedJuridicalDocumentType.Id;
                juridicalDocument.OpeningDate = null;
                juridicalDocument.SignatureDate = formatDateValue(juridicalDocument.SignatureDateFormatted);
                juridicalDocument.DistractDate = formatDateValue(juridicalDocument.DistractDateFormatted);
                juridicalDocument.RenovationDate = formatDateValue(juridicalDocument.RenovationDateFormatted);
                juridicalDocument.RenewalNumber = juridicalDocument.RenewalNumber || null;
                juridicalDocument.RelatedJuridicalDocumentId = vm.isDistractModal
                    ? juridicalDocument.RelatedJuridicalDocumentId
                    : null;

                if (!juridicalDocument.Id) {
                    JuridicalDocumentService
                        .post(juridicalDocument)
                        .then(success => {
                            vm.juridicalDocuments.push(success);
                            vm.closeJuridicalModal();

                            HelperService.successCallback();
                            HelperService.stopLoading('.modal-loader');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.modal-loader');
                        })
                } else {
                    JuridicalDocumentService
                        .put(juridicalDocument)
                        .then(success => {
                            let index = vm.juridicalDocuments.findIndex(x => x.Id == juridicalDocument.Id);
                            vm.juridicalDocuments[index] = success;

                            vm.closeJuridicalModal();

                            HelperService.successCallback();
                            HelperService.stopLoading('.modal-loader');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.modal-loader');
                        })
                }
            }

            function getJuridicalDocumentTypes() {
                return JuridicalDocumentService
                    .getTypes()
                    .then(success => vm.juridicalTypes = Array.isArray(success) ? success : [],
                        error => HelperService.errorCallback(error));
            }

            function formatDateValue(date) {
                if (!date)
                    return null;

                let momentDate = HelperService.getMomentDate(date);

                if (!momentDate || !momentDate.isValid())
                    return null;

                return momentDate.format('YYYY-MM-DD');
            }

            function resetDatePickerState() {
                vm.datePickerOpen = {
                    SignatureDate: false,
                    DistractDate: false,
                    RenovationDate: false
                };

                vm.datePickerModels = {
                    SignatureDate: null,
                    DistractDate: null,
                    RenovationDate: null
                };
            }

            function syncAllDatePickerModels() {
                syncDatePickerModel('SignatureDate');
                syncDatePickerModel('DistractDate');
                syncDatePickerModel('RenovationDate');
            }

            function syncDatePickerModel(field) {
                const formattedValue = vm.juridicalDocumentData && vm.juridicalDocumentData[`${field}Formatted`];
                const momentDate = formattedValue ? HelperService.getMomentDate(formattedValue) : moment();

                vm.datePickerModels[field] = momentDate && momentDate.isValid()
                    ? momentDate.toDate()
                    : moment().toDate();
            }

            function buildRenewalOptions() {
                return [
                    { Value: 1, Description: 'Primeira renovacao' },
                    { Value: 2, Description: 'Segunda renovacao' },
                    { Value: 3, Description: 'Terceira renovacao' },
                    { Value: 4, Description: 'Quarta renovacao' },
                    { Value: 5, Description: 'Quinta renovacao' },
                    { Value: 6, Description: 'Sexta renovacao' },
                    { Value: 7, Description: 'Setima renovacao' },
                    { Value: 8, Description: 'Oitava renovacao' },
                    { Value: 9, Description: 'Nona renovacao' },
                    { Value: 10, Description: 'Decima renovacao' }
                ];
            }

            function normalizeText(value) {
                return (value || '')
                    .toString()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toUpperCase();
            }

            function initVars() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;
                vm.canUserView = $rootScope.canUserView;
                vm.canUserDelete = $rootScope.canUserDelete;

                vm.juridicalDocumentData = {};
                vm.selectedJuridicalDocumentType = null;
                vm.selectedFile = null;
                vm.isDistractModal = false;
                vm.relatedJuridicalDocument = null;
                resetDatePickerState();
                vm.datePickerConfig = {
                    startView: 'day',
                    minView: 'day',
                    modelType: 'Date'
                };
                vm.juridicalDocuments = Array.isArray(vm.unitData && vm.unitData.JuridicalDocument) ? vm.unitData.JuridicalDocument : [];
                vm.renewalOptions = buildRenewalOptions();

                vm.flowOptions = {
                    query: () => {
                        let unitId = vm.unitData && vm.unitData.Id ? vm.unitData.Id : 0;

                        return {
                            Path: `juridical/${unitId}`
                        }
                    }
                }

                angular.extend(vm.flowOptions, HelperService.getFlowOptionsDefaultsJuridical());
            }

            function init() {
                if (!vm.unitData || !vm.unitData.Id)
                    return;

                HelperService.startLoading('.loading-holder');

                initVars();

                $q.all([getJuridicalDocumentTypes()])
                    .then(() => {
                        HelperService.stopLoading('.loading-holder');
                    })
            }
        }

        return {
            bindToController: true,
            controller: UnitJuridicalDocumentsDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/unit-juridical-documents/unit-juridical-documents.html`,
            scope: {
                unitData: '=',
                show: '='
            }
        }
    }
}());
